import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { appDescriptionLenses } from 'root/src/client/logic/app/lenses'

const { viewSliderShowItems } = appDescriptionLenses

export default (state, { moduleId }) => viewSliderShowItems(moduleId, moduleDescriptions)
